import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogData } from '@app/common/components/confirm-dialog/confirm-dialog-data';
import { ConfirmDialogComponent } from '@app/common/components/confirm-dialog/confirm-dialog.component';

const defaultConfirmData = {
  title: 'confirm.default.title',
  message: 'confirm.default.message',
};

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  matDialog = inject(MatDialog);

  private static instance: ConfirmDialogService | null = null;
  constructor() {
    ConfirmDialogService.instance = this;
  }
  public static getInstance() {
    return ConfirmDialogService.instance;
  }

  openDialog(data: ConfirmDialogData = defaultConfirmData): Observable<boolean> {
    return this.matDialog
      .open(ConfirmDialogComponent, {
        data: data,
        disableClose: true,
      })
      .afterClosed();
  }
}
